// Host requirements, version 2026-11-03 (venue-search VS1.3, Braeden).
// Adds statement 5: every venue offers a bookable period of at least 8 hours.
// Never edit a released version. To change a statement, add a new file with a
// new date and point CURRENT_HOST_REQUIREMENTS in ./index.js at it
// (hostRequirements.test.js fails if a released file changes).

const requirements = {
  version: '2026-11-03',
  statements: [
    {
      id: 'vendors',
      text: 'Bookers may hire any vendors they want. I will not require a list of approved vendors.'
    },
    {
      id: 'eventsAllowed',
      text: 'My HOA, my city, and any lease or insurance allow events at this property, at the guest count I will list.'
    },
    {
      id: 'rightToList',
      text: 'I own this property, or I have the right to list it and sign for it.'
    },
    {
      id: 'accurate',
      text: 'My photos and details will be true, and I will keep them up to date.'
    },
    {
      id: 'dayBlock',
      text: 'My venue will offer a bookable period of at least 8 hours.'
    }
  ]
};

export default requirements;
